import { serialize } from '@/@core/libs/serialize/util'
import Http from './http'

// Registered bots (Telegram today). Credentials are write-only: the list/show
// endpoints only say whether a token exists; the token itself is returned
// solely by botSecret, on an explicit admin click.
export const botsList = (params = '') => Http.get(`/admin/bots${serialize(params)}`)
export const botByID = id => Http.get(`/admin/bots/${id}`)
export const botCreate = (params = '') => Http.post('/admin/bots', params)
export const botUpdate = (params = '') => Http.put(`/admin/bots/${params.id}`, params)
export const botDestroy = (params = '') => Http.delete(`/admin/bots/${params.id}`)

// getMe against Telegram with the bot's stored token; stores the @username.
export const botCheck = id => Http.post(`/admin/bots/${id}/check`)

// Reveals { data: { data: { token, secret_token } } } (throttled by the API).
export const botSecret = id => Http.get(`/admin/bots/${id}/secret`)
